import React, {PropTypes} from 'react';
import _ from 'lodash';
import {FileUpload} from 'routes/app/components/FileInput';
import Row from 'routes/app/components/Row';
import Col from 'routes/app/components/Col';
import Button from 'routes/app/components/Button';
import Table from 'routes/app/components/Table';
import {apiRoutes} from 'app/globals';
import * as api from 'app/lib/ajax';

import './style.scss';


class Attachments extends React.Component {
    static propTypes = {
        documentId: PropTypes.string.isRequired,
        attachments: PropTypes.array
    };

    static defaultProps = {
        attachments: []
    };

    constructor(props) {
        super(props);
        this.state ={
            uploaded: props.attachments
        };
    }

    fileUploadSuccessHandler = (response) => {
        response.json().then((data) => {
            this.setState({
                uploaded: this.state.uploaded.concat([{id: data.id, filename: response.file.name}])
            });
        });
    };

    deleteFile = (fileId) => {
        api.del(apiRoutes.DELETE_FILE({id:fileId}))();
        let uploaded = _.filter(this.state.uploaded, file => file.id !== fileId);
        this.setState({
            uploaded
        });
    };

    render() {
        return (
            <div className="attachments">
                {this.state.uploaded && this.state.uploaded.length > 0 &&
                <Table striped bordered>
                    <tbody>
                    {this.state.uploaded.map((file, index) => (
                        <tr key={file.id}>
                            <td><a href={apiRoutes.DOWNLOAD_FILE({id:file.id})} target="_blank">{file.filename}</a></td>
                            <td>
                                <Button className="btn-remove btn-circle right" onClick={()=>this.deleteFile(file.id)} flat>
                                    <i className="material-icons">delete</i>
                                </Button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
                }

                <Row className="attachments__upload">
                    <Col s={12}>
                        <FileUpload onFileUploadSuccess={this.fileUploadSuccessHandler}
                                    uploadUrl={apiRoutes.UPLOAD_DOC({id:this.props.documentId})}
                                    buttonText="Pick a file"
                                    errorMessage="Upload failed"
                            {...this.props} />

                    </Col>
                </Row>
            </div>
        );
    }
}

export default Attachments;